"use strict";

exports.__esModule = true;
exports.usePagination = void 0;
var _react = require("react");
var usePagination = function usePagination(_ref) {
  var items = _ref.items,
    itemsPerPage = _ref.itemsPerPage;
  var _useState = (0, _react.useState)(1),
    currentPage = _useState[0],
    setCurrentPage = _useState[1];
  var indexOfLastItem = currentPage * itemsPerPage;
  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
  var currentItems = items == null ? void 0 : items.slice(indexOfFirstItem, indexOfLastItem);
  return {
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    currentItems: currentItems
  };
};
exports.usePagination = usePagination;